import { useEffect, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";

export default function Scanner({ onResult, onClose }) {
  const [err, setErr] = useState("");
  const [manual, setManual] = useState("");
  useEffect(() => {
    const s = new Html5Qrcode("wms-scanner");
    let stopped = false;
    s.start({ facingMode: "environment" }, { fps: 10, qrbox: 230 }, (text) => {
      if (stopped) return;
      stopped = true;
      s.stop().catch(() => {}).finally(() => onResult(text));
    }, () => {}).catch((e) => setErr(`Kamera tidak tersedia / 无法使用相机: ${e?.message || e}`));
    return () => { if (!stopped) { stopped = true; s.stop().catch(() => {}); } };
  }, [onResult]);
  return (
    <div className="modal-overlay" data-testid="scanner-modal">
      <div className="modal-box small">
        <h3>Scan Barcode / 扫码</h3>
        <div id="wms-scanner" className="scanner-box" />
        {err && <div className="alert warning">{err}</div>}
        <label>Input Manual / 手动输入</label>
        <input value={manual} onChange={(e) => setManual(e.target.value)} placeholder="MAT-YYMMDD-0001" data-testid="scanner-manual-input" />
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose} data-testid="scanner-close-btn">Tutup / 关闭</button>
          <button className="btn btn-primary" onClick={() => manual && onResult(manual.trim())} data-testid="scanner-manual-submit">Gunakan / 使用</button>
        </div>
      </div>
    </div>
  );
}
